// What the browser says about the link, as MediaAutoLoad's `MediaLink` (PARITY P299). The Network
// Information API (`navigator.connection`, Chromium and Android browsers): `saveData` = the reader
// turned Data Saver on (constrained — they ASKED for less traffic), `type === 'cellular'` = billed by
// the byte (expensive). Where the API is missing (Safari, Firefox) the link is `unknown`, which
// MediaAutoLoad treats as free — guessing wrong there costs a slow picture, never a hidden one.
import { MediaAutoLoad, type MediaLink } from './mediaAutoLoad';

/** The slice of `NetworkInformation` read here. */
export interface ConnectionInfo {
  saveData?: boolean;
  type?: string;
}

function fromConnection(connection: ConnectionInfo | null | undefined): MediaLink {
  if (!connection) return MediaAutoLoad.unknown;
  return { isExpensive: connection.type === 'cellular', isConstrained: connection.saveData === true };
}

export const NetworkLink = { fromConnection } as const;
